export const AUTH_API_URL = {
  LOGOUT: 'user/logout',
  LOGIN: 'user/signin',
  SIGNUP: 'user/signup',
  USER: 'user/{{type}}',
  FORGOT_PASSWORD: 'user/forgot-password',
  RESET_PASSWORD_TOKEN: 'user/validate-reset-password-token',
  RESET_PASSWORD: 'user/reset-password',
  ACCESS_MODULES: 'business-role/access-modules',
};
